import { useActiveProfile } from "app/providers/ActiveProfileProvider";
import { useProfile } from "app/providers/ProfileProvider";
import NavigationItem from "app/models/navigationItem";
import {
  useIsBusinessCustomerMode,
  useIsCustomerMode,
} from "app/providers/ActiveCustomerAccountProvider";

export default function useAppLinks(appLinks: NavigationItem[]) {
  const activeProfile = useActiveProfile();
  const profile = useProfile();
  const isCustomerMode = useIsCustomerMode();
  const isBusinessCustomerMode = useIsBusinessCustomerMode();

  return appLinks.filter((r) => {
    if (
      Boolean(
        activeProfile?.profile_type === "business" &&
          activeProfile.role_name === "Viewer"
      ) &&
      r.label === "Profile"
    ) {
      return false;
    }

    const countryIncluded = r.countries
      ? r.countries?.includes(profile?.country_code ?? "")
      : true;

    if (
      isCustomerMode &&
      (isBusinessCustomerMode
        ? r.mode?.includes("business-customer")
        : r.mode?.includes("individual-customer")) &&
      countryIncluded
    ) {
      return true;
    }

    if (
      Boolean(activeProfile?.profile_type === "business" && !isCustomerMode) &&
      r.mode?.includes("business") &&
      countryIncluded
    ) {
      return true;
    }

    if (
      Boolean(activeProfile?.profile_type === "personal") &&
      r.mode?.includes("personal") &&
      countryIncluded
    ) {
      return true;
    }

    return false;
  });
}
